export default __webpack_public_path__ + "static/logo-fc6c249ed31728fef334dc21c9f514b8.svg";